import { render, staticRenderFns } from "./EvaluasiUser.vue?vue&type=template&id=0866150e&"
import script from "./EvaluasiUser.vue?vue&type=script&lang=js&"
export * from "./EvaluasiUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports